// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BreadCrumbs_wrapper__1LzRb"};